import api from './client';

/**
 * Get the authentication token for API calls
 * Uses the same pattern as other admin endpoints - they use adminToken from localStorage
 * but fall back to token if adminToken doesn't exist
 */
const getAuthToken = () => {
  // Use the same pattern as InterviewSessions and other admin components
  return localStorage.getItem('adminToken') || localStorage.getItem('token');
};

/**
 * Fetch comments for a specific module and object
 * @param {string} module - The module name (e.g., 'session', 'candidate')
 * @param {string|number} objectId - The ID of the object
 * @returns {Promise} API response with comments array
 */
export const fetchComments = async (module, objectId) => {
  try {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    const response = await api.get('/comments/', {
      params: {
        module,
        object_id: objectId,
      },
      skipAuth: true, // Skip interceptor auth, we handle it explicitly
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching comments:', error);
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
    }
    throw error;
  }
};

/**
 * Create a new comment
 * @param {string} module - The module name (e.g., 'session', 'candidate')
 * @param {string|number} objectId - The ID of the object
 * @param {string} comment - The comment text (max 300 characters)
 * @param {boolean} isInternal - Whether the comment is internal
 * @returns {Promise} API response with created comment
 */
export const createComment = async (module, objectId, comment, isInternal = false) => {
  try {
    const token = getAuthToken();
    if (!token) {
      throw new Error('No authentication token found');
    }
    
    const response = await api.post('/comments/', {
      module,
      object_id: objectId,
      comment: comment.trim(),
      is_internal: isInternal,
      metadata: {},
    }, {
      skipAuth: true, // Skip interceptor auth, we handle it explicitly
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating comment:', error);
    if (error.response) {
      console.error('Response status:', error.response.status);
      console.error('Response data:', error.response.data);
    }
    throw error;
  }
};

